import { Link } from "react-router-dom";
import { MaskedText, Reveal, FloatingBlob } from "@/components/motion";

// Inner-page hero with breadcrumb, overline, H1, intro,
// and an optional arched image floated to the right of the title.
export const PageHero = ({
  overline,
  titleLines = [],
  intro,
  breadcrumb = [],
  heroImage, // { src, alt }
}) => {
  return (
    <section className="relative overflow-hidden pt-28 md:pt-32 pb-8 md:pb-12 px-6 md:px-12 grain">
      <FloatingBlob color="blush" size={340} className="-top-10 -right-16" delay={0.1} />
      <FloatingBlob color="sage" size={280} className="bottom-0 -left-16" delay={0.4} drift={30} />
      <div className="relative mx-auto max-w-[1400px] grid md:grid-cols-[1fr_auto] gap-8 md:gap-12 items-start">
        <div className="min-w-0">
          {breadcrumb.length > 0 && (
            <nav aria-label="Breadcrumb" className="mb-5">
              <ol className="flex flex-wrap items-center gap-2 text-xs tracking-[0.15em] uppercase text-cove-taupe">
                {breadcrumb.map((c, i) => (
                  <li key={c.path} className="flex items-center gap-2">
                    {i < breadcrumb.length - 1 ? (
                      <Link to={c.path} className="hover:text-cove-slate transition-colors">
                        {c.name}
                      </Link>
                    ) : (
                      <span className="text-cove-olive">{c.name}</span>
                    )}
                    {i < breadcrumb.length - 1 && <span className="text-cove-rose">/</span>}
                  </li>
                ))}
              </ol>
            </nav>
          )}

          {overline && (
            <Reveal>
              <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-cove-rose mb-4">
                {overline}
              </p>
            </Reveal>
          )}

          {titleLines.length > 0 && (
            <h1 className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-cove-slate max-w-3xl text-balance">
              <MaskedText lines={titleLines} />
            </h1>
          )}

          {intro && (
            <Reveal delay={0.25}>
              <p className="mt-5 max-w-xl text-lg md:text-xl leading-relaxed text-cove-olive text-pretty">
                {intro}
              </p>
            </Reveal>
          )}
        </div>

        {heroImage && (
          <Reveal>
            <div
              className="w-52 sm:w-64 md:w-72 lg:w-80 overflow-hidden shadow-[0_25px_50px_rgba(41,54,80,0.15)] justify-self-end mt-2 md:mt-0"
              style={{ borderTopLeftRadius: "50% 55%", borderTopRightRadius: "50% 55%" }}
            >
              <img
                src={heroImage.src}
                alt={heroImage.alt}
                loading="lazy"
                className="w-full h-72 sm:h-80 md:h-96 lg:h-[26rem] object-cover"
              />
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
};

export default PageHero;
